import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";

export function ARPCard({ device }) {
  const theme = useTheme();
  return (
    <Box width="100%" sx={{ marginLeft: 3, mb: 1 }}>
      <Stack>
        <Typography variant="caption">
          <b>{device.device_type}</b>
        </Typography>
        <Typography variant="overline" style={{ marginLeft: 20 }}>
          <b style={{ color: theme.palette.secondary.main }}>{device.mac_address}</b>
          <b style={{ color: "lightgrey" }}> • </b>
          <b style={{ color: "grey" }}>{device.ip_address}</b>
        </Typography>
      </Stack>
    </Box>
  );
}
